
import React from "react";
import Compound from "../Compound";
import { NavLink } from "react-router-dom";
import { FactorState } from "./MultiFactor";
import * as ReactRouterDom from "react-router-dom";
import { FormInput, i18nManager } from "../../i18n";
import { Schemes, Debugger, Utils, CacheManager } from "../../utils";
import { ButtonManageRef, Checkbox, NoseurObject } from "@rivtn/noseur";
import { AuthService, IBusiness, IProfile, SanitizedResponse } from "../../services";

function SignIn() {
    const labels = i18nManager.Labels.sign_in;
    const navigate = ReactRouterDom.useNavigate();
    const authService = AuthService.getInstance();
    const [success, setSuccess] = React.useState<boolean>();
    const [staySignedIn, setStaySignedIn] = React.useState<boolean>();
    const [searchParams, setSearchParams] = ReactRouterDom.useSearchParams(window.location.search);
    const { state } = ReactRouterDom.useLocation() as { state: { postOnly?: boolean; profile: IProfile; referrer: string; } };
    const error = searchParams.get("error");
    const redirectLocation = searchParams.get("rloc") ?? state?.referrer ?? process.env.REACT_APP_CONSIVIUS_BASE_API_URL ?? "https://account.rivtn.com";
    const [searchParams2, __] = ReactRouterDom.useSearchParams(decodeURIComponent(redirectLocation.substring(redirectLocation.indexOf("?"))));
    const [referrerDomain, trustedDomainsSchemes, trustedSchemeBids] = Utils.extractTrustedDomainData(searchParams2.get("ref") ?? "/");

    React.useEffect(() => {
        if (error) {
            Utils.reportError(error);
            searchParams.delete("error");
            setSearchParams(searchParams);
        }
    }, []);

    return Compound({
        success,
        desc: labels.desc,
        title: labels.title,
        actionLabel: labels.action_label,
        secondaryAction: labels.secondary_action,
        secondaryFormElement: renderSecondaryForm(),
        onInput: (_: string, _v: any) => setSuccess(undefined),
        form: labels.form.reduce((acc, formInput) => {
            if (formInput.name === "email" && state?.profile?.email) formInput.value = state?.profile?.email;
            acc.push(formInput);
            return acc;
        }, [] as FormInput[]),
        onAction: (buttonManageRef: ButtonManageRef | null, formValues: NoseurObject<any>, onDone?: () => void) => {
            formValues["token_expiry_in_minutes"] = 24;
            formValues["session_expiry_in_days"] = (staySignedIn ? 90 : 1);
            if (referrerDomain in trustedDomainsSchemes) {
                formValues["authenticating_platform"] = trustedDomainsSchemes[referrerDomain];
            }
            authService.signin(formValues).then(({ sanitized }: SanitizedResponse<any>) => {
                setSuccess(true);
                onDone && onDone();
                const sessionExpiryDate = new Date((new Date()).getTime() + ((sanitized.session_expiry_in_hours - 2) * 60 * 60000));
                const profile = { ...state?.profile, ...sanitized, email: formValues.email, session_expiry_date: sessionExpiryDate.getTime() };
                CacheManager.putProfile(profile, () => navigateForward(sanitized));
                Debugger.log("SignIn:onAction:success", sanitized);
            }).catch((error: SanitizedResponse<any>) => {
                setSuccess(false);
                Utils.reportError(error);
                buttonManageRef?.setLoadingState(false);
                delete formValues["session_expiry_in_days"];
                delete formValues["authenticating_platform"];
                delete formValues["token_expiry_in_minutes"];
            });
        }
    });

    function renderSecondaryForm() {
        return (<div className="signin-secondary">
            <Checkbox scheme={Schemes.RIVTN_PATULCIUS} label={labels.stay_signed_in} onChange={(e: any) => setStaySignedIn(e.checked)} />
            <NavLink to={"/forgot-password"}>{labels.forgot_password}</NavLink>
        </div>);
    }

    async function navigateForward(response: any) {
        const isOauth = searchParams.has("rloc");
        if (!Object.keys(response.required_fa).length) {
            Utils.redirectToReferrer(redirectLocation, response, isOauth, state?.postOnly);
            return;
        }
        let factorState = FactorState.EMAIL_FACTOR;
        if (response.required_fa.email && response.required_fa.phone) {
            factorState = FactorState.MULTI_FACTOR;
        } else if (response.required_fa.phone) {
            factorState = FactorState.PHONE_FACTOR;
        } else if (response.required_fa.security_questions) {
            factorState = FactorState.SECURITY_QUESTIONS;
        } else if (response.required_fa.actor_authenticator) {
            factorState = FactorState.AUTHENTICATOR;
        }
        navigate("/fa", {
            state: {
                isOauth,
                response,
                factorState,
                redirectLocation,
                postOnly: searchParams.has("postonly"),
            }
        });
    }

}

export default SignIn;
